import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Divider,
Table, TableBody, TableCell,TableHead, TableRow, TablePagination, Checkbox } from '@material-ui/core';
import { } from '@material-ui/icons';
import PropTypes from 'prop-types';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center',
        alignContent: 'center',
        overflowX: 'auto'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
        padding: 5,
    },
    table: {
        minWidth: 700,
        maxHeight: '60vh'
    },
})

let id = 0;

//CLASS DEF AND CONSTRUCTOR - START WITH AN EMPTY STATE
class PageName extends Component{
    constructor(props){
        super(props)
        this.state = {
            checkedList : [],
            page: 0,
            rowsPerPage: 10,
            searchTerm: ''
        }
    }

    //COMPONENT DID MOUNT FUNCTION, RUN ON PAGE LOAD//
    async componentDidMount() {
        //If you wanted to call each user group from the DB you'd use these ref's
        // const studentRef = db.collection('Users').where('accountType', '==', 'Student');
        // const teachRef = db.collection('Users').where('accountType', '==', 'Teacher');
        // const parentRef = db.collection('Users').where('accountType', '==', 'Parent');
        const allRef = db.collection('Users').where('accountType', '>', 'Admin'); //Everyone who isn't an admin (all groups start with a letter '>' A in the alphabet)
        var studentArr = [];
        var teacherArr = [];
        var parentArr = [];
        var allUsersArr = [];
        var snapshot = await allRef.get();
        snapshot.forEach(doc => {
            allUsersArr.push(doc.data())
        });

        allUsersArr.forEach(entry => {
            switch (entry.accountType){
                case 'Teacher':
                    teacherArr.push(entry)
                    break;
                 
                case 'Student':
                    studentArr.push(entry)
                    break;

                case 'Parent':
                    parentArr.push(entry)
                    break;

                default: 
                    console.error('We have an erroneous user entry in the DB')
            }
        });
        this.setState({
            ...this.state,
            allUsers: allUsersArr,
            students: studentArr,
            teachers: teacherArr,
            parents: parentArr,
            checkedList: []
        });
        console.log(this.state);
    }

    //CREATE DATA FOR TABLE
    createData(name, accountType, currentLvl, email) {
        id += 1;
        return {id, name, accountType, currentLvl, email }; 
    }

    //ITEMS FOR THE TABLE   
    rows= (arr) => {
        const output = []
        console.log(arr);
        arr.map(record => {
            output.push(
                this.createData(record.displayName, record.accountType, record.CurrentLevel, record.email)
            )
        })
        return output
    }
    // [
    //         arr.map(record => {
    //             return (
    //                 this.createData(record.displayName, record.accountType, record.CurrentLevel, record.email)
    //             )
    //         })
    //     ];

    searchArr = (arr, searchTerm ) => {
        console.log(searchTerm)
        // searchTerm = searchTerm.toLowerCase()
        var output = [];
        arr.forEach(e => {
            if (e.name.search(searchTerm) != -1) {
                output.push(e)
            }
        })
        return output
    }

    checked = () => event => {
        console.log(event.target.value)
        var arr = this.state.checkedList;
        console.log(arr)
        const index = arr.indexOf(event.target.value)
        console.log(index)
        if  (index != -1) {
            arr.splice(index, 1)
        } else {
            arr.push(event.target.value)
        }
        console.log(arr)
        this.setState({
            checkedList: arr
        })
        console.log(this.state.checkedList)
    }

    checkedAll = () => {
        console.log(this.makeTableData())
    }

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: event.target.value
        })
    }

    makeTableData = () => {
        return this.searchArr(this.rows(this.state.allUsers), this.state.searchPhrase)
        
    }

    //THIS CAN BE MADE DEEPER TO COMPLETLY GET THEIR DATA OUT OF THE SYSTEM
    // deleteSelected = async (arr) => { 
    //     console.log('TO DELETE', arr)

        
    //     arr.forEach( async person => {
    //         var snapshot =  await db.collection('Users').where('displayName', '==', person).get()
    //         snapshot.docs.forEach(doc => {
    //             var password
    //             if (doc.data().OGPassword) {
    //                 password = doc.data().OGPassword
    //             } else {
    //                 password = doc.data().password
    //             }
    //             var email = doc.data().email
    //             creds.secondaryfb.auth().signInWithEmailAndPassword(email, password)
    //             .then(()=>{
    //                 creds.secondaryfb.auth().onAuthStateChanged(function(user){
    //                     if (user) {
    //                         console.log(user)
    //                             user.delete().then(async function(){
    //                                 window.alert('User: ' + user + 'Deleted')
    //                                 var dltRef = await db.collection('Users').doc(doc.id)
    //                                 dltRef.delete()
    //                                 .then(() => { 
    //                                     if (arr.indexOf(person) == (arr.length - 1)){
    //                                         window.alert(arr)
    //                                         // window.location.reload() 
    //                                         // console.log('192', arr, arr.length, arr.indexOf(person), (arr.indexOf(person) == (arr.length - 1))) //DEBUG
    //                                     }
    //                                     return
    //                                 })
    //                             })
    //                     } else {
    //                         console.error('There was an error signing in with the secondary auth')
    //                     }
    //                 })
    //             })
    //             .catch(function(error){
    //                 console.error('Error Code :' + error.code)
    //                 console.error(error.message)
    //             })
    //         })
    //     })
    // }

    deleteSelected = async (arr) => { 
        var objArr = []
        arr.forEach( async person => {
            var snapshot =  await db.collection('Users').where('displayName', '==', person).get()
            snapshot.docs.forEach(doc => {
                var password
                if (doc.data().OGPassword) {
                    password = doc.data().OGPassword
                } else {
                    password = doc.data().password
                }
                var email = doc.data().email
                objArr.push({email: email, pword: password, id: doc.id})
            })
            if (objArr.length == arr.length) {
                this.authDelete(objArr)
                this.dbDelete(objArr)
            }
        })
        console.log(objArr)
        
        // creds.secondaryfb.auth().signInWithEmailAndPassword(email, password)
        // .then(()=>{
        //     creds.secondaryfb.auth().onAuthStateChanged(function(user){
        //         if (user) {
        //             console.log(user)
        //                 user.delete().then(async function(){
        //                     window.alert('User: ' + user + 'Deleted')
        //                     var dltRef = await db.collection('Users').doc(doc.id)
        //                     dltRef.delete()
        //                     .then(() => { 
        //                         if (arr.indexOf(person) == (arr.length - 1)){
        //                             window.alert(arr)
        //                             // window.location.reload() 
        //                             // console.log('192', arr, arr.length, arr.indexOf(person), (arr.indexOf(person) == (arr.length - 1))) //DEBUG
        //                         }
        //                         return
        //                     })
        //                 })
        //         } else {
        //             console.error('There was an error signing in with the secondary auth')
        //         }
        //     })
        // })
        // .catch(function(error){
        //     console.error('Error Code :' + error.code)
        //     console.error(error.message)
        // })
    }

    authDelete = async arr => {
        var toDelete = []
        arr.forEach( obj => { 
            try {
                creds.secondaryfb.auth().signInWithEmailAndPassword(obj.email, obj.pword)
                .then(async () => {
                    var user = await creds.secondaryfb.auth().currentUser
                    if (user){
                        //They have been signed in
                        user.delete().then( () =>{
                            console.log('USER DELETED')
                        }).catch(function(error){
                            //an error with the delete?
                            console.log('ERROR ON DLT - ', error, user)
                        })
                    } else {
                        //They are not signed in
                        console.log('ERROR - USER WAS NOT SIGNED IN', obj)
                    }
                })
            } catch(error) {
                console.log('ERROR - WE COULDNT SIGN IN', obj, error)
            } 
            
        })
        this.componentDidMount()
    }

    dbDelete =  arr => { 
        arr.forEach(  obj => { 
            var dltRef = db.collection('Users').doc(obj.id)
            try {
                dltRef.delete()
                .then(() => { 
                    if (arr.indexOf(obj) == (arr.length - 1)){

                    }
                    return console.log('db delete successful')
                })
            }
            catch (error) {
                console.log('There was an error', error)
            }
            
        })
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render(){
        const searchOutPut = <h1>hi</h1>
        const { classes } = this.props;
        return (
            sessionStorage.getItem('AccountType') == 'Admin' ? (
                <Paper className={classes.root}>
                    {this.state.allUsers ? (
                        <div className={classes.container}>
                            <Typography variant='headline'>
                                Manage Accounts
                            </Typography>
                            <Divider/>
                            <br/>
                            <TextField className={classes.TextField}
                                onChange={this.handleChange('searchPhrase')}
                                value={this.state.searchPhrase}
                                helperText='Search for Accounts via display name'
                            />
                            <br/>
                            <br/>
                            <Paper style={{overflowX: 'auto'}}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><Checkbox disabled={true}/></TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell>Account Type</TableCell>
                                        <TableCell>Current Level</TableCell>
                                        <TableCell>Email</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.makeTableData()
                                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                        .map(row => {
                                        return (
                                            
                                            <TableRow 
                                                key={row.id}
                                                hover
                                                tabIndex={-1}>
                                                <TableCell><Checkbox  value={row.name} onChange={this.checked()} checked={(this.state.checkedList.indexOf(row.name) != -1)}/></TableCell>
                                                <TableCell component="th" scope="row">
                                                {row.name}
                                                </TableCell>
                                                <TableCell>{row.accountType}</TableCell>
                                                <TableCell>{row.currentLvl}</TableCell>
                                                <TableCell>{row.email}</TableCell>
                                                
                                            </TableRow>
                                            
                                        )
                                    })}
                                 </TableBody>   
                            </Table>
                            <TablePagination
                                component='div'
                                count={this.makeTableData().length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                  }}
                                  nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                  }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                  />
                            </Paper>
                            <br/>
                            <Button variant='raised' onClick={() => this.deleteSelected(this.state.checkedList)}>
                                    Delete Selected
                            </Button>
                        </div>
                    ) : (
                        <div/>
                    )}
                </Paper>
            ) : (
              window.location.replace('/')  
            )
            
        )
    }
}
export default withStyles(styles)(PageName);


// WEBPACK FOOTER //
// ./src/admin/deleteAccount.jsx